import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { reduxForm, SubmissionError, formValueSelector, getFormAsyncErrors } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { addRfid, updateRfid } from 'services/payments-service';
import { getCategoriesList, getVehicleClassesList, getOptionsList } from 'services/types';
import { Confirm, Button, themes, Popup2 } from 'libs/ui';
import { ParkingFilter2, WhiteStyledField, Title, ErrorMsg, required, rfid } from 'libs/form';
import { StyledButtonContainer, TextareaStyledField } from './rfid-form.styled';
import { asyncValidate } from './rfid-form.validate';

/**
 * rfid form
 * @param {*} props
 * @returns
 */
const RfidForm = (props) => {
  const {
    error,
    destroy,
    refresh,
    setMessage,
    form,
    handleSubmit,
    close,
    type,
    clientId,
    // id,
    tariffs,
    parkingId,
    // transportClass,
    // transportCategory,
  } = props;
  // console.log('🚀 ~ RfidForm ~ rfid:', props.rfid, props.formAsyncErrors);
  const [confirm, setConfirm] = useState(false);
  // const [data, setData] = useState(null);

  const isAdd = type === 'addForm';
  window.rfidFormEdit = !isAdd;

  const { t } = useTranslation();
  const asyncErrors = props.formAsyncErrors;

  useEffect(() => {
    if (asyncErrors?.rfid === 'Метка с таким номером привязана к другому клиенту') {
      // setConfirm(true);
    }
  }, [asyncErrors]);

  /**
   * close confirm
   */
  const closeConfirm = () => {
    setConfirm(false);
  };

  /**
   * after submit
   */
  const afterSubmit = () => {
    refresh();
    setMessage('Изменения сохранены');
    setTimeout(() => {
      setMessage('');
    }, 3000);
    close();
    destroy(form);
  };

  /**
   * save
   * @param {*} values
   * @returns
   */
  const submit = (values) => {
    // data
    const test = false;
    const out = { ...values };
    // out.is_blocked = out.is_blocked === 'true' || out.is_blocked === true;
    // out.mean_type = 'subscription';
    out.vehicle_category = out.vehicle_category ? parseInt(out.vehicle_category) : null;
    out.vehicle_class = out.vehicle_class ? parseInt(out.vehicle_class) : null;
    out.tariff_id = out.tariff_id ? out.tariff_id : null;
    if (clientId) {
      out.client_id = clientId;
    }

    // if (!isAdd) {
    //   out.id = id;
    //   // confirm
    //   if (out.mean_id !== props.initialValues.mean_id) {
    //     setData(out);
    //     setConfirm(true);
    //     return false;
    //   }
    // }
    if (test) {
      console.log('🚀 ~ submit ~ out:', out);
      return Promise.resolve();
    }

    // method
    const method = isAdd ? addRfid : updateRfid;
    return method(out)
      .then(() => {
        afterSubmit();
      })
      .catch((errors) => {
        // console.log('🚀 ~ submit ~ errors:', errors);
        if (errors && errors.data) {
          throw new SubmissionError({
            _error: errors.data.type,
          });
        }
        if (errors && errors.field) {
          throw new SubmissionError({
            [errors.field]: errors.message,
          });
        }
      });
  };

  const changeRfid = () => {
    window.rfidFormEdit = true;

    // this.setState({ edit1: true });
    // this.props.dispatch(change(this.props.form, 'id1', window.rfid.id));
    // this.props.dispatch(change(this.props.form, 'mode', 'change'));
    // this.props.dispatch(change(this.props.form, 'owner', window.rfid.owner));
    // this.props.dispatch(change(this.props.form, 'vehicle_plate', window.rfid.vehicle_plate));
    // this.props.dispatch(change(this.props.form, 'vehicle_category', window.rfid.vehicle_category));
    // this.props.dispatch(change(this.props.form, 'vehicle_class', window.rfid.vehicle_class));
    // this.props.dispatch(change(this.props.form, 'tariff_id', window.rfid.tariff_id));
  };

  /**
   * close form
   */
  const cancel = () => {
    close();
    destroy(form);
  };

  const title = isAdd ? t('form.Добавить СО') : t('form.Изменить СО');
  const disabledRfid = window.config.central && !parkingId;
  const requiredT = required(t);
  const rfidT = rfid(t);

  return (
    <Popup2 w={482} top={3}>
      <Title>{title}</Title>
      <form onSubmit={handleSubmit(submit)}>
        <ErrorMsg error={error} />

        <input type="hidden" name="mode" />
        <input type="hidden" name="id1" />
        <input type="hidden" name="client_id1" />
        {isAdd && <ParkingFilter2 withEmpty required />}

        <WhiteStyledField validate={[requiredT, rfidT]} placeholder="78497503480098" mask="999999" error={error} type="text" label={t('sections.RFID')} name={isAdd ? 'rfid' : 'mean_id'} disabled={disabledRfid} />

        <WhiteStyledField validate={requiredT} placeholder={t('form.Иванов Иван Иванович')} type="text" error={error} label={t('form.ФИО водителя')} name="owner" />

        <WhiteStyledField validate={requiredT} type="select" label="Класс ТС" error={error} name="vehicle_class">
          {isAdd && <option value={null}>{t('form.Выберите класс ТС')}</option>}
          {getVehicleClassesList()}
        </WhiteStyledField>

        <WhiteStyledField validate={requiredT} type="select" label={t('filter.Категория СО')} error={error} name="vehicle_category">
          {isAdd && <option value={null}>{t('form.Выберите категорию')}</option>}
          {getCategoriesList()}
        </WhiteStyledField>

        <WhiteStyledField className="shortfield" type="dateTime" label={t('form.Дата действия с')} placeholder={t('form.Дата действия с')} name="start_at" />

        <WhiteStyledField className="shortfield" type="dateTime" label={t('form.Дата действия по')} placeholder={t('form.Дата действия по')} name="end_at" />

        <WhiteStyledField validate={requiredT} placeholder={t('form.А000AA 000 rus')} type="text" label={t('sections.ГРЗ')} error={error} name="vehicle_plate" />

        <WhiteStyledField
          className="shortfield"
          type="select"
          label={t('form.Тариф')}
          name="tariff_id"
          error={error}
          // disabled={!transportClass || !transportCategory}
          validate={required(t)}
        >
          {isAdd && <option value="">{t('form.Выберите тариф')}</option>}
          {getOptionsList(tariffs)}
        </WhiteStyledField>

        {isAdd && <TextareaStyledField type="textarea" placeholder={t('filter.Напишите свой комментарий')} label={t('filter.Комментарий')} name="comment" />}

        <StyledButtonContainer space="20px">
          <Button type="button" onClick={cancel}>
            {t('buttons.Отменить')}
          </Button>
          <Button theme={themes.blue}>
            <i className="fa fa-save" />
            {t('buttons.Сохранить')}
          </Button>
        </StyledButtonContainer>

        {/* {confirm && (
          <Confirm
            width={'550px'}
            title={'Номер карты для данной записи будет изменён. Предыдущий номер карты будет удалён. Продолжить?'}
            type="danger"
            cancelButton={{ text: 'Отмена', func: closeConfirm }}
            acceptButton={{ text: 'Изменить номер карты', func: submitAfterConfirm, theme: themes.red }}
          />
        )} */}
        {confirm && (
          <Confirm
            width={'480px'}
            title={t('messages.Метка с таким номером привязана к другому клиенту Вы уверены, что хотите добавить метку к текущему клиенту?')}
            type="danger"
            cancelButton={{ text: t('buttons.Отменить'), func: closeConfirm }}
            acceptButton={{ text: t('grid.Подтвердить'), func: changeRfid, theme: themes.blue }}
          />
        )}
      </form>
    </Popup2>
  );
};

//vehicle_category: props.categories ? props.categories[0].id : null,

let reduxRfidForm = reduxForm({
  form: 'rfidForm',
  asyncValidate,
  asyncBlurFields: ['rfid'],
  destroyOnUnmount: false,
})(RfidForm);

const selector = formValueSelector('rfidForm');

reduxRfidForm = connect((state, props) => {
  // const transportClass = selector(state, 'vehicle_class');
  // const transportCategory = selector(state, 'vehicle_category');
  const parkingId = selector(state, 'parking_id');
  const rfid = selector(state, 'rfid');
  const out = { ...props.initialValues, mode: 'normal', client_id1: props.clientId, id1: props.initialValues.id };
  return {
    // transportClass,
    // transportCategory,
    rfid,
    parkingId,
    formAsyncErrors: getFormAsyncErrors('rfidForm')(state),
    initialValues: out,
  };
}, {})(reduxRfidForm);

export default reduxRfidForm;
